/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Reorbit component for PMD Phase 
Author: Deimos Space UK

Version: 1.0
*/

import React from 'react'
import Select from 'react-select';
import { Row, Col, Form,  OverlayTrigger, Tooltip } from 'react-bootstrap';
import style from '../PMDPhase.module.css'
function Reorbit(props) {

    return (
        <div>
            <Row className={style.rowForm}>
                <Col xs={6} md={4} >

                    <Select
                        isDisabled={true}
                        className="react-select"
                        classNamePrefix="react-select"
                        value={props.step4?.reorbitData?.disposalSystem}
                        onChange={(value) => props.onChangeDisposalSystemReorbit(value)}
                        options={[
                            { value: 'chemical', label: 'Chemical' },
                            { value: 'electrical', label: 'Electrical' },
                        ]}>

                    </Select>
                </Col>
                <Col xs={6} md={4} >
                    <Form.Group >
                        <Form.Label>Target-orbit deorbit altitude [km]</Form.Label>
                        <Form.Control
                            isInvalid={isNaN(props.step4?.reorbitData?.reorbitAltitude) && props.step4?.reorbitData?.reorbitAltitude !== ''} 
                            disabled={props.disabled}
                            value={props.step4?.reorbitData?.reorbitAltitude}
                            onChange={e => props.changeReorbitAltitude(e.target.value)} type="string" />
                    </Form.Group>
                </Col >
                {props.step4 && props.step4?.reorbitData && props.step4?.reorbitData?.disposalSystem.value === 'chemical' ?
                    <>
                        <Col xs={6} md={4} >
                            <Form.Group >
                            <OverlayTrigger
                                key={'right'}
                                placement={'left'}
                                overlay={
                                    <Tooltip id={`tooltip-right`}>
                                        Number of Hohmann transfer manoeuvers required to reach the desired orbit.
                                    </Tooltip>
                                }>
                                <Form.Label>Hohmann transfer manoeuvres</Form.Label>
                            </OverlayTrigger>
                                <Form.Control
                                    isInvalid={isNaN(props.step4?.reorbitData?.hohmannTransfer) && props.step4?.reorbitData?.hohmannTransfer !== ''} 
                                    disabled={props.disabled}
                                    value={props.step4?.reorbitData?.hohmannTransfer}
                                    onChange={e => props.changeHohmanTransferReorbit(e.target.value)} type="string" />
                            </Form.Group>
                        </Col >

                    </>
                    : null
                }

            </Row>


        </div>
    )
}

export default Reorbit